import TemplatesRoutes from './routes'

const Templates = () => <TemplatesRoutes />

export default Templates
